import { Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useTranslation } from 'react-i18next';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import PageContent from '../PageContent/PageContent';
import Sidebar from '../Sidebar/Sidebar';

const NotFoundError: any = () => {

    const { t } = useTranslation();
    document.title = t('Document_title_error');
    const title: string = t('GenericError_title');
    const message: string = t('NotFoundError_message');

    return (

        <Box id="error">
            <Box className="banner" />
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                <Grid size={{ xs: 4, sm: 8, md: 4 }}>
                    <Sidebar showPanel={false} />
                </Grid>
                <Grid size={{ xs: 4, sm: 8, md: 8 }}>
                    <Header>{title}</Header>
                    <PageContent title={message} />
                    <Footer />
                </Grid>
            </Grid>
        </Box>
    );
}

export default NotFoundError;